import { IMdlCustomDialogConfiguration, MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { Injectable } from '@angular/core';
import { DATA_REVISION_DIALOG_TOKEN, DataRevisionComponent, ModalData } from './data-revision/data-revision.component';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class ModalDialogService {

    public modalSubject = new BehaviorSubject<ModalData>(null);
    constructor(private readonly dialogService: MdlDialogService) { }

    public showDialog(data?: ModalData): Observable<any> {
        this.modalSubject.next(data);
        const configDialog: IMdlCustomDialogConfiguration = {
            component: DataRevisionComponent,
            providers: [{
                provide: DATA_REVISION_DIALOG_TOKEN,
                useValue: data
            }],
            isModal: true,
            classes: 'revision-data-dialog',
            styles: { 'width': '57%', 'padding': '0em', 'border-radius': '10px' },
            clickOutsideToClose: false
        };

        return this.dialogService.showCustomDialog(configDialog)
            .pipe(
                switchMap(dialog => dialog.onHide()),
                map(dialogResult => dialogResult)
            );
    }
    public updateDialog(updatedData: ModalData): void {
        this.modalSubject.next(updatedData);  
    }
}